"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseObject = void 0;
var log_1 = require("./log");
var id = 0;
var BaseObject = /** @class */ (function () {
    function BaseObject(name) {
        name = name || "Object";
        this._id = name + "_" + id++;
        this.log = log_1.LogManager.getLog(this._id);
    }
    BaseObject.prototype.toString = function () {
        return this._id;
    };
    return BaseObject;
}());
exports.BaseObject = BaseObject;
